export default __webpack_public_path__ + "c62ed64075dad618a4debd63dfdb5d08.png";